import { EntitySelectEntity } from '@factorialco/f0-react/dist/experimental'
import {
  FinanceCreditNoteSequenceEntityFragment,
  FinanceSalesInvoiceSequenceEntityFragment,
} from 'generated/resources/graphql'

import { BaseSerialSequenceFragment } from './types'

const SEPARATOR = ' → '

type SequenceInput =
  | FinanceSalesInvoiceSequenceEntityFragment
  | FinanceCreditNoteSequenceEntityFragment

/**
 * Maps any sequence type to BaseSerialSequenceFragment by creating a new object
 * with all required properties. This avoids type assertions while maintaining type safety.
 */
export function toBaseSerialSequence(sequence: SequenceInput): BaseSerialSequenceFragment {
  return {
    __typename: 'FinanceSalesInvoiceSequence',
    id: sequence.id,
    archivedAt: sequence.archivedAt,
    humanReadablePreview: sequence.humanReadablePreview,
    lastGeneratedSerial: sequence.lastGeneratedSerial,
    legalEntityId: sequence.legalEntityId,
    name: sequence.name,
    pattern: sequence.pattern,
    startFrom: sequence.startFrom,
  }
}

export function mapSalesInvoiceSequences(
  serialSequences: FinanceSalesInvoiceSequenceEntityFragment[]
): EntitySelectEntity[] {
  return serialSequences.map(mapSerialSequences)
}

export function mapCreditNoteSequences(
  serialSequences: FinanceCreditNoteSequenceEntityFragment[]
): EntitySelectEntity[] {
  return serialSequences.map(mapSerialSequences)
}

function mapSerialSequences(
  serialSequences:
    | FinanceSalesInvoiceSequenceEntityFragment
    | FinanceCreditNoteSequenceEntityFragment
): EntitySelectEntity {
  return {
    id: serialSequences.id,
    name: serialSequences.name + SEPARATOR + serialSequences.humanReadablePreview,
    avatar: undefined,
    searchKeys: [
      serialSequences.name,
      serialSequences.pattern,
      String(serialSequences.startFrom),
      String(serialSequences.lastGeneratedSerial),
    ],
  }
}
